module.exports = __webpack_public_path__ + "static/7-1617380e0dea667b61cf44e86f3d0f10.woff";